/** author: 胡枭 */

import request from '@/utils/request.js'

const baseUrl = process.env.VUE_APP_COMPANY_API
const portalApi = process.env.VUE_APP_PORTAL_API

// 企业门户相关接口 -----------------------------------------
// 获取企业门户信息
export function getCompanyPortalApi() {
  return request({
    url: portalApi + '/companies/oneself/portals',
    method: 'get'
  })
}

// 新增企业门户
export function postCompanyPortalApi(data) {
  return request(
    {
      url: portalApi + '/companies/oneself/portals',
      method: 'post',
      data
    },
    true
  )
}

// 更新企业门户
export function putCompanyPortalApi(data) {
  return request(
    {
      url: portalApi + '/companies/oneself/portals',
      method: 'put',
      data
    },
    true
  )
}

// 获取企业产品分页列表
export function getCompanyProductionListApi(params) {
  return request({
    url: portalApi + `/companies/oneself/products/page`,
    method: 'get',
    params
  })
}

// 获取企业产品详情
export function getCompanyProductionInfoApi(companyId, productId) {
  return request({
    url: portalApi + `/companies/${companyId}/products/${productId}`,
    method: 'get'
  })
}

// 新增企业产品
export function postCompanyProductionApi(data) {
  return request(
    {
      url: portalApi + '/companies/oneself/products',
      method: 'post',
      data
    },
    true
  )
}

// 更新企业产品
export function putCompanyProductionApi(data) {
  const { productId } = data
  return request(
    {
      url: portalApi + `/companies/oneself/products/${productId}`,
      method: 'put',
      data
    },
    true
  )
}

// 删除企业产品
export function deleteCompanyProductionApi(productId) {
  return request({
    url: portalApi + `/enterprise/product/${productId}`,
    method: 'delete'
  })
}

/** ****************************************** 证件管理 **************************************** */
// 获取证件分类列表
export function getCertificationCategoryApi() {
  return request({
    url: baseUrl + `/certification-category/ancestor-category`,
    method: 'get'
  })
}

// 分页获取证件列表
export function getCertificationListApi(params) {
  return request({
    url: baseUrl + `/enterprise/certificate/manage/page`,
    method: 'get',
    params
  })
}

// 新增公司证书
export function addCertificateApi(data) {
  return request({
    url: baseUrl + `/enterprise/certificate`,
    method: 'post',
    data
  })
}

// 更新公司证书
export function updateCertificateApi(data) {
  return request({
    url: baseUrl + `/enterprise/certificate`,
    method: 'put',
    data
  })
}

// 查看公司证书详情
export function getCertificateDetailApi(params) {
  return request({
    url:
      baseUrl +
      `/enterprise/certificate/category/${params.certificateCategoryId}`,
    method: 'get'
  })
}
